import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { FaTimes } from "react-icons/fa";
import { useSidebarContext } from "../sidebarReducer/sidebar_reducer";

function Sidebar() {
  const { sidebarOpen, closeSidebar } = useSidebarContext();

  return (
    <Wrapper>
      <aside className={`${sidebarOpen ? "sidebar show-sidebar" : "sidebar"}`}>
        <div className="nav-header">
          <h1 className="alforoan">Alforoan</h1>
          <button className="close-btn" onClick={closeSidebar}>
            <FaTimes />
          </button>
        </div>
        <ul className="page-link-list">
          <li className="home">
            <Link to="home" smooth={true} onClick={closeSidebar}>
              Home
            </Link>
          </li>
          <li>
            <Link to="about" smooth={true} onClick={closeSidebar}>
              About
            </Link>
          </li>
          <li className="projects">
            <Link to="projects" smooth={true} onClick={closeSidebar}>
              Projects
            </Link>
          </li>
          <li className="github">
            <a
              target="_blank"
              rel="noopener nonreferrer"
              href="https://github.com/Alforoan"
              onClick={closeSidebar}
            >
              Github
            </a>
          </li>
        </ul>
      </aside>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  max-width: 80vw;

  .sidebar {
    position: fixed;
    transition: all 0.3s linear;
    transform: translate(-100%);
    background: lightgray;
    top: 0;
    left: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    padding-top: 2rem;
    padding-left: 2rem;
    z-index: -1;
  }
  .show-sidebar {
    transform: translate(0);
    z-index: 999;
  }
  .close-btn {
    background: transparent;
    border-color: transparent;
    transition: all 0.3s linear;
    cursor: pointer;
    margin-top: 0.2rem;
    font-size: 2rem;
    padding-right: 3rem;
    svg {
      font-size: 2rem;
    }
    padding-bottom: 0.7rem;
  }
  .alforoan {
    font-size: 2rem;
    border: none;

    margin-bottom: 1rem;
  }
  .nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .page-link-list {
    list-style: none;
    cursor: pointer;
    li {
      margin-bottom: 0.5rem;
      font-size: 1.5rem;
    }
  }
  .github {
    a {
      text-decoration: none;
    }
    a:visited {
      color: black;
    }
  }
  @media screen and (min-width: 1000px) {
    display: none;
  }
  @media screen and (max-width: 600px) {
    .close-btn {
      padding-right: 2.7rem;
    }
  }
`;

export default Sidebar;
